import { actions, initialState } from './constants'
import { factoryReducer as createFactoryReducer, flattenStringMap } from '../../../../../reducers/utils'

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.INITIALIZE:
      return {
        filter: payload.filter,
      }

    case actions.CHANGE_FILTER:
      return {
        filter: payload.filter,
      }

    default:
      return state
  }
}

export default createFactoryReducer(
  // @ts-ignore
  {
    registerType: actions.INITIALIZE,
  },
  flattenStringMap(actions),
  reducer,
  (meta) => meta.ID,
)
